import React, { useState, useEffect } from 'react'
import './styles.css'

import { useSearchParams } from 'react-router-dom'

import { Snackbar, TextField } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { styled } from '@mui/material/styles'
import CustomCheckbox from 'src/components/CustomCheckbox'
import { useQuery } from 'src/hooks'

const LoginInput = styled(TextField)(() => ({
  marginBottom: '12px',
  fontFamily: 'Source Sans 3',
  '& .MuiInputBase-input': {
    fontFamily: 'Source Sans 3'
  }
}))

const RegistrationActivate = () => {
  const query = useQuery()

  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState(query.get('email') || '')
  const [companyName, setCompanyName] = useState('')
  const [companyRevenue, setCompanyRevenue] = useState('')

  const [phone, setPhone] = useState('')
  const [employees, setEmployees] = useState('')

  const [checked, setChecked] = useState('')
  const [agree, setAgree] = useState(false)

  const [dataSent, setDataSent] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [errors, setErrors] = useState({})
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    if (searchParams.has('error')) {
      setErrors({ ...errors, tokenError: searchParams.get('error') })
      setTimeout(() => {
        setErrors({ ...errors, tokenError: null })
      }, 5000)
      searchParams.delete('error')
      setSearchParams(searchParams)
    }
  }, [])

  const validateForm = () => {
    let errors = {}

    if (!email) {
      errors.email = 'Email is required'
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = 'Email is invalid'
    }

    if (!firstName) {
      errors.firstName = 'First Name is required'
    }

    if (!lastName) {
      errors.lastName = 'Last Name is required'
    }

    if (!companyName) {
      errors.companyName = 'Company Name is required'
    }

    if (!checked || !agree) {
      errors.agree = `You need to agree to the ${
        !checked && !agree ? 'TOBA, EULA and the Privacy Policy' : !agree ? 'Privacy Policy' : 'TOBA and EULA'
      }`
    }

    setErrors(errors)
    return Object.keys(errors).length === 0
  }

  const body = {
    sourceUrl: window.location.href,
    userEmail: email,
    userFirstName: firstName,
    userLastName: lastName,
    companyName: companyName,
    phoneNumber: phone,
    employeesNumber: employees,
    ...(companyRevenue && { companyRevenue: companyRevenue })
  }

  const handleSubmit = e => {
    e.preventDefault()

    if (validateForm()) {
      setLoading(true)

      fetch(window._env_.REACT_APP_API_HOST + '/v1/special-offer/companies/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      }).then(response => {
        if (response.status) {
          setLoading(false)
          setDataSent(true)
          // clearForm()
          // setSuccessMessage('Success! Data has been sent.')
        } else {
          setLoading(false)
          // setErrorMessage('Something went wrong, please try again')
        }
      })
    }
  }
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    setError(false)
  }

  const isEea = query.get('iseea') == 'true'
  const ishsbc = query.get('ishsbc') == 'true'

  const privacyLink = isEea
    ? 'https://www.ajg.com/se-en/eea-privacy-notice/'
    : 'https://www.ajg.com/uk/global-privacy-notice/'

  return (
    <div className='login-page column'>
      <div className='logo'>
        <img src='/images/logo.png' width={'300px'} alt='' />
      </div>
      <div className='login-form-container mob-login-form-container column'>
        <form className='column' onSubmit={handleSubmit}>
          {dataSent ? (
            <>
              <div className='column column-center'>
                <svg
                  style={{ marginBottom: '24px' }}
                  width='112'
                  height='112'
                  viewBox='0 0 112 112'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    opacity='0.16'
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M56 112C86.9279 112 112 86.9279 112 56C112 25.0721 86.9279 0 56 0C25.0721 0 0 25.0721 0 56C0 86.9279 25.0721 112 56 112Z'
                    fill='#00BC62'
                  />
                  <g filter='url(#filter0_d_360_35055)'>
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M79.7744 38.82C78.648 37.4334 76.6041 37.2221 75.2205 38.351L47.5584 60.8834L36.3493 54.4157C35.1674 53.7316 33.6784 53.8707 32.6407 54.753C31.2812 55.9098 31.1129 57.9619 32.2652 59.3263L39.3125 67.6496L39.2977 67.6626L44.7821 74.1174L44.9929 74.3435C45.6218 74.9478 46.432 75.25 47.2403 75.25C48.0893 75.25 48.9346 74.9182 49.5691 74.2638L79.5895 43.1207C80.7289 41.9417 80.8084 40.0936 79.7744 38.82Z'
                      fill='url(#paint0_linear_360_35055)'
                    />
                  </g>
                  <defs>
                    <filter
                      id='filter0_d_360_35055'
                      x='31.5'
                      y='37.625'
                      width='49'
                      height='39.125'
                      filterUnits='userSpaceOnUse'
                      colorInterpolationFilters='sRGB'
                    >
                      <feFlood floodOpacity='0' result='BackgroundImageFix' />
                      <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                      />
                      <feOffset dy='1.5' />
                      <feComposite in2='hardAlpha' operator='out' />
                      <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.0032804 0 0 0 0 0.61672 0 0 0 0 0.347725 0 0 0 1 0'
                      />
                      <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_360_35055' />
                      <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_360_35055' result='shape' />
                    </filter>
                    <linearGradient
                      id='paint0_linear_360_35055'
                      x1='74.1597'
                      y1='5.09505'
                      x2='38.0323'
                      y2='9.27992'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stopColor='#00BA97' />
                      <stop offset='1' stopColor='#00BC62' />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <p style={{ textAlign: 'center' }} className='reset-pass-description fs20 lh12 mb40'>
                Thank you for your interest in the Gallagher Cyber Defence Centre. We’ve received your request, and a
                member of our team will be in touch with you shortly.
                <br />
                <br />
                If you have any immediate questions, please don’t hesitate to contact us at{' '}
                <span style={{ fontWeight: '600' }}>
                  <a href='mailto:CyberRM@ajg.com' style={{ textDecoration: 'none', color: 'rgb(43, 90, 128)' }}>
                    CyberRM@ajg.com.
                  </a>
                </span>
              </p>
            </>
          ) : (
            <>
              <p className='login-title' style={{ fontSize: '30px' }}>
                Welcome to Cyber Defence Centre
              </p>
              <p style={{ marginBottom: 30, opacity: 0.8, marginTop: 20, fontSize: '16px' }}>
                To send a general enquiry to our office, complete the form and our team member will respond to you
                shortly. For complaints please see our{' '}
                <a
                  href='https://www.ajg.com/uk/complaints/'
                  target='_blank'
                  style={{ color: '#0246F8', textDecoration: 'none' }}
                  rel='noreferrer'
                >
                  complaints information
                </a>
                .
                <br />
                <br />
                For information on how we use your personal data please refer to our{' '}
                <a
                  style={{ color: '#0246F8', textDecoration: 'none' }}
                  href={privacyLink}
                  rel='noreferrer'
                  target='_blank'
                >
                  Privacy Notice
                </a>
                . Required fields are marked with an asterisk (*)
              </p>

              <div className='column'>
                <div className='row' style={{ gap: 12 }}>
                  <LoginInput
                    error={errors.firstName}
                    value={firstName}
                    onChange={e => setFirstName(e.target.value)}
                    placeholder='First Name*'
                    label='First Name*'
                    fullWidth
                  />
                  <LoginInput
                    error={errors.lastName}
                    value={lastName}
                    onChange={e => setLastName(e.target.value)}
                    placeholder='Last Name*'
                    label='Last Name*'
                    fullWidth
                  />
                </div>
                <div className='row' style={{ gap: 12 }}>
                  <LoginInput
                    error={errors.email}
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder='Work email*'
                    label='Work email*'
                    fullWidth
                  />
                  <LoginInput
                    error={errors.companyName}
                    value={companyName}
                    onChange={e => setCompanyName(e.target.value)}
                    placeholder='Company name*'
                    label='Company name*'
                    fullWidth
                  />
                </div>
                {ishsbc && (
                  <div className='row' style={{ gap: 12 }}>
                    <LoginInput
                      value={employees}
                      onChange={e => setEmployees(e.target.value)}
                      placeholder='Employee Count'
                      label='Employee Count'
                      fullWidth
                    />
                    <LoginInput
                      value={companyRevenue}
                      onChange={e => setCompanyRevenue(e.target.value)}
                      placeholder='Annual Company Revenue'
                      label='Annual Company Revenue'
                      fullWidth
                    />
                  </div>
                )}
                <LoginInput
                  error={errors.phone}
                  value={phone}
                  onChange={e => setPhone(e.target.value)}
                  placeholder='Phone number'
                  label='Phone number'
                  fullWidth
                />
                {!ishsbc && (
                  <LoginInput
                    error={errors.employees}
                    value={employees}
                    onChange={e => setEmployees(e.target.value)}
                    placeholder='Number of employees'
                    label='Number of employees'
                    fullWidth
                  />
                )}

                <div className='row row-center' style={{ marginBottom: 15 }}>
                  <CustomCheckbox checked={checked} onChange={() => setChecked(prev => !prev)} />
                  <p>
                    I have read and agree to the{' '}
                    <a
                      style={{ color: '#0246F8', textDecoration: 'none' }}
                      href='/assets/security-awareness-toba.pdf'
                      target='_blank'
                    >
                      TOBA
                    </a>{' '}
                    and{' '}
                    <a
                      style={{ color: '#0246F8', textDecoration: 'none' }}
                      href='https://admin.gallaghercdc.cyberlift.ai/assets/TERMS%20&%20CONDITIONS%20FOR%20THE%20USE%20OF%20THE%20PROVIDER%20SERVICES%20(EULA).pdf'
                      target='_blank'
                      rel='noreferrer'
                    >
                      EULA
                    </a>
                    <span style={{ color: '#b40020' }}>*</span>
                  </p>
                </div>
                <div className='row row-center' style={{ marginBottom: 15 }}>
                  <CustomCheckbox checked={agree} onChange={() => setAgree(prev => !prev)} />
                  <p>
                    I agree to the processing of my personal data in accordance with the{' '}
                    <a
                      style={{ color: '#0246F8', textDecoration: 'none' }}
                      href={privacyLink}
                      rel='noreferrer'
                      target='_blank'
                    >
                      Privacy Notice
                    </a>
                    <span style={{ color: '#b40020' }}>*</span>
                  </p>
                </div>
              </div>

              {(error || errors.agree) && <p className='error-text'>{errors.agree}</p>}

              <LoadingButton
                type='submit'
                loading={loading}
                onClick={handleSubmit}
                sx={{
                  mt: '30px',
                  mb: '16px',
                  borderRadius: 0,
                  textTransform: 'none',
                  height: '60px',
                  backgroundColor: '#0246F8',
                  fontFamily: 'Source Sans 3'
                }}
                variant={'contained'}
              >
                Activate
              </LoadingButton>
            </>
          )}
        </form>

        {errors?.tokenError && (
          <div className='column column-center'>
            <p className='error-text' style={{ marginTop: 20 }}>
              {' '}
              {errors?.tokenError}
            </p>
          </div>
        )}
      </div>
      <div className='spacer'></div>

      <Snackbar
        sx={{
          '& .MuiSnackbarContent-root': {
            backgroundColor: '#B40020',
            borderRadius: 0
          }
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        open={error}
        autoHideDuration={6000}
        onClose={handleClose}
        message={error}
      />
      <Snackbar
        sx={{
          '& .MuiSnackbarContent-root': {
            backgroundColor: '#B40020',
            borderRadius: 0
          }
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        open={!!errors?.tokenError}
        autoHideDuration={6000}
        onClose={handleClose}
        message={errors?.tokenError}
      />
    </div>
  )
}

export default RegistrationActivate
